// extracted by mini-css-extract-plugin
module.exports = {"root":"FileBtn_root__298HN","disabled":"FileBtn_disabled__21RRz","warn":"FileBtn_warn__JooOi","fade":"FileBtn_fade__2bCmN"};